import type {FC} from "react";

import {TextFormField} from "./TextFormField";
import type {NumericSetterFunc, StringSetterFunc} from "../wizard.types";
import {NumericFormField} from "./NumericFormField";

/**
 * Wizard form field: apartment quantity.
 */
export const ApartmentQuantityField: FC<{
  apartmentQuantity: number | undefined,
  setApartmentQuantity: NumericSetterFunc
}> = ({apartmentQuantity, setApartmentQuantity}) => (
  <NumericFormField labelText='Asuntojen lukumäärä *' testId='apartment-quantity'
                    value={apartmentQuantity}
                    onChange={setApartmentQuantity}
  />
)


/**
 * Wizard form field: building quantity.
 */
export const BuildingQuantityField: FC<{
  buildingQuantity: number | undefined,
  setBuildingQuantity: NumericSetterFunc
}> = ({buildingQuantity, setBuildingQuantity}) => (
  <NumericFormField labelText='Rakennusten lukumäärä *' testId='building-quantity'
                    tooltip='Montako rakennusta, joissa on asuntoja, taloyhtiössä on?'
                    value={buildingQuantity}
                    onChange={setBuildingQuantity}
  />)

/**
 * Wizard form field: company name.
 */
export const CompanyNameField: FC<{
  companyName: string,
  setCompanyName: StringSetterFunc
}> = ({companyName, setCompanyName}) =>
  (
    <TextFormField labelText='Taloyhtiön nimi *' testId='company-name' value={companyName}
                   onChange={setCompanyName}/>
  )

/**
 * Wizard form field: floor quantity.
 */
export const FloorQuantityField: FC<{
  floorQuantity: number | undefined,
  setFloorQuantity: NumericSetterFunc
}> = ({floorQuantity, setFloorQuantity}) => (
  <NumericFormField labelText='Kerrosten lukumäärä *' testId='floor-quantity'
                    tooltip='Jos määrä vaihtelee eri talojen välillä, anna tähän korkeimman talon kerrosluku.'
                    value={floorQuantity}
                    onChange={setFloorQuantity}
  />)

/**
 * Wizard form field: stairwell quantity.
 */
export const StairwellQuantityField: FC<{
  stairwellQuantity: number | undefined,
  setStairwellQuantity: NumericSetterFunc
}> = ({stairwellQuantity, setStairwellQuantity}) => (
  <NumericFormField labelText='Rappujen lukumäärä *' testId='stairwell-quantity'
                    tooltip='Montako rappua tai porrasta taloyhtiössä on?'
                    value={stairwellQuantity}
                    onChange={setStairwellQuantity}
  />)
